/**
 * Consent Settings Page
 * Page wrapper for Consent Management component
 */

import React from "react";
import { Shield } from "lucide-react";
import { PageBanner } from "../../components/ui/PageBanner";
import { useI18nStore } from "../../stores/i18nStore";
import { ConsentManagement } from "../../components/consent/ConsentManagement";

export const ConsentSettingsPage: React.FC = () => {
  const { t } = useI18nStore();
  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <PageBanner
        icon={Shield}
        title={t.settings2ConsentPageTitle}
        description={t.settings2ConsentPageDescription}
      />

      <ConsentManagement />
    </div>
  );
};
